export default {
    defaultAnonymousRoute: "/login",
    defaultAuthenticatedRoute: "/dashboard",
    defaultSuperAdminRoute: "/admin",
    dashboardRoute: "/dashboard",
    logoutRoute: "/logout",
    loginRoute: "/login",
    developerRoute: "/developer",
    adminRoute: "/admin",
    publicOnboarding: "/hello/:slug",
    publicOnboardingThankYou: "/hello/thank-you",
    publicOnboardingConfirm: "/hello/confirm/:confirmationId",
    
    // Admin sub-routes
    adminConversationsRoute: "/admin/conversations",
    adminMessagesRoute: "/admin/messages",
    adminConversationDetailRoute: "/admin/conversations/:id",
    adminCommunitiesRoute: "/admin/communities",
    adminCommunityDetailRoute: "/admin/communities/:id",
    adminUsersRoute: "/admin/users",
    adminSystemEvents: "/admin/system-events",
    adminFlexcoRoute: "/admin/flexco",
    adminDevtoolsRoute: "/admin/devtools",
    adminCommunityRecommendationsRoute: "/admin/communities/:energyCommunityId/recommendations",
    adminOrganizationsRoute: "/admin/organizations",
    adminOrganizationDetailRoute: "/admin/organizations/:id",
    adminEcAdminsRoute: "/admin/ec-admins",
    adminAccountsRoute: "/admin/accounts",
    adminFilesRoute: "/admin/files",
    adminUserTransactionsRoute: "/admin/user-transactions",
    adminBillingRoute: "/admin/billing",
    adminWhitelabelsRoute: "/admin/whitelabels",
    adminWhitelabelDetailRoute: "/admin/whitelabels/:id",
    adminDocumentDesignsRoute: "/admin/whitelabels?tab=designs",
    adminDocumentDesignDetailRoute: "/admin/whitelabels/designs/:id",
}